var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-view"},[(_vm.activeQuestion)?_c('advisor-question',{attrs:{"question":_vm.activeQuestion,"selected":_vm.selectedAnswer},on:{"answer":_vm.onAnswer,"skip":_vm.onSkip}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }